import cx from 'classnames'
import { useEffect } from 'react'

import Payment from './components/Payment/Payment'
import Price from './components/Price/Price'
import Reservation from './components/Reservation/Reservation'
import Seats from './components/Seats/Seats'

import { BASKET_TYPES, RELATIVE_BASKET_TYPES } from './constants'

import hocConnect from './hocConnect'

import './Basket.scss'

const Basket = ({
    data,
    show,
    variant,
    selectedSeats,
    onConfirm,
    onReserve,
    onBuy,
    onPayment,
    loading,
    basketLoading,
    getData,
    setSlug,
}) => {
    useEffect(() => {
        getData()
    }, [])

    return (
        <div className={cx('basket-wrapper', show && 'show', RELATIVE_BASKET_TYPES.includes(variant) && 'relative')}>
            <div className={'basket'}>
                {variant === BASKET_TYPES.SEATS && (
                    <Seats loading={loading || basketLoading} selectedSeats={selectedSeats} onConfirm={onConfirm} />
                )}
                {variant === BASKET_TYPES.PRICE && (
                    <Price data={data} loading={loading || basketLoading} onReserve={onReserve} onBuy={onBuy} />
                )}
                {variant === BASKET_TYPES.PAYMENT && (
                    <Payment data={data} loading={loading || basketLoading} onPayment={onPayment} setSlug={setSlug} />
                )}
                {variant === BASKET_TYPES.RESERVATION && (
                    <Reservation
                        data={data}
                        loading={loading || basketLoading}
                        onPayment={onPayment}
                        setSlug={setSlug}
                    />
                )}
            </div>
        </div>
    )
}

export default hocConnect(Basket)
